import { Text, mergeClasses } from "@fluentui/react-components";
import { Flex } from "../flex";
import { useStyles } from "./style";
import { MessagingInteractionProps } from "./types";
import { OfferingVariableTextView } from "@/components/atoms/offeringVariableTextView";
import { SkillsDisplay } from "./Skills/SkillsDisplay";
import {
	InteractionOfferingDescription,
	OfferingSourceType,
} from "@/components/atoms/interactionOfferingDescription";

export const MessagingDetailsCard = (props: MessagingInteractionProps) => {
	const {
		contactName,
		description,
		queueName,
		transferInitiatorName,
		offeringVariableText,
		offeringVariableTextIsAiGenerated,
		fallbackFrom,
		skills,
	} = props;
	const style = useStyles();

	const getPreviousActionComponent = () => {
		if (transferInitiatorName) {
			return (
				<InteractionOfferingDescription
					resourceName={transferInitiatorName}
					actionType={OfferingSourceType.Transfer}
				/>
			);
		}

		if (fallbackFrom) {
			return (
				<InteractionOfferingDescription
					resourceName={fallbackFrom}
					actionType={OfferingSourceType.Fallback}
				/>
			);
		}

		return <></>;
	};

	return (
		<Flex className={style.cardContainer} column>
			{getPreviousActionComponent()}
			<div className={style.innerContainer}>
				<Text
					align="center"
					weight="bold"
					block
					className={style.whiteText}
					truncate
					wrap={false}
					title={contactName}
				>
					{contactName}
				</Text>
				<span className={style.details}>
					{description && (
						<Text
							align="center"
							block
							className={style.whiteText}
							truncate
							wrap={false}
							title={description}
						>
							{description}
						</Text>
					)}
				</span>
				<div className={style.footer}>
					<Text
						align="center"
						block
						className={mergeClasses(style.text, style.grayText)}
						truncate
						wrap={false}
						title={queueName}
					>
						{queueName}
					</Text>
					<SkillsDisplay skills={skills} />
				</div>
				<OfferingVariableTextView offeringVariableText={offeringVariableText} offeringVariableTextIsAiGenerated={offeringVariableTextIsAiGenerated} />
			</div>
		</Flex>
	);
};
